<template>
  <div
    class="tw:w-full tw:bg-orange-600 tw:px-4 tw:py-2 tw:flex tw:items-center tw:justify-center tw:gap-4 max-dmarc-bar-height"
  >
    <span class="tw:text-white tw:body-1 tw:line-clamp-2">
      {{ trans._notifications.dmarcStrictAlignment }}
    </span>

    <EdroneButton :loading="isLoading" size="medium" @click="goToSendingDomains">
      {{ trans._notifications.fixNow }}
    </EdroneButton>
  </div>
</template>

<script lang="ts" setup>
import EdroneButton from "edrone-components/EdroneButton.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { DMARC_BAR_HEIGHT } from "vue-app/types/enums";

const isLoading = ref(false);
const router = useRouter();

const goToSendingDomains = () => {
  isLoading.value = true;
  router.push({ name: "PageSendingDomain" });
  // Reset loading after navigation
  setTimeout(() => {
    isLoading.value = false;
  }, 100);
};

const dmarcBarHeightCss = `${DMARC_BAR_HEIGHT}rem`;
</script>

<style scoped>
.max-dmarc-bar-height {
  max-height: v-bind(dmarcBarHeightCss);
}
</style>